<template>
  <div class="parking-area">
    <input-label :text="$t('parkingArea.type.label')"/>
    <input-selector v-model="typeSync" :options="typeOptions" button-class="type-buttons"/>
    <next-transition :visible="typeSync !== ''">
      <input-label :text="$t('parkingArea.portage.label')"/>
      <input-selector
        v-model="portageSync"
        :options="portageOptions"
        button-class="portage-options-buttons"/>
    </next-transition>
    <next-transition :visible="isPortageMore50">
      <input-label :text="$t('parkingArea.portage.specify')"/>
      <input-number-range
        :step="10"
        :min="50"
        :max="1000"
        unit="m"
        v-model="portageNumber"
      />
    </next-transition>
    <next-transition :visible="portageSync !== ''">
      <input-label :text="$t('parkingArea.vl.label')"/>
      <input-selector v-model="vlSync" :options="vlOptions"/>
    </next-transition>
  </div>
</template>

<script>
import InputSelector from '@/components/utils/InputSelector.vue';
import InputLabel from '@/components/utils/InputLabel.vue';
import InputNumberRange from '../utils/InputNumberRange.vue';
import NextTransition from '@/components/utils/NextTransition.vue';

export default {
  name: 'ParkingArea',
  components: {
    NextTransition,
    InputNumberRange,
    InputLabel,
    InputSelector,
  },
  data() {
    return { portageNumber: null };
  },
  computed: {
    vlOptions() {
      return [
        {
          label: this.$t('base.yes'),
          value: 0,
        },
        {
          label: this.$t('base.no'),
          value: 1,
        },
        {
          label: this.$t('base.duno'),
          value: -1,
        },
      ];
    },
    typeSync: {
      get() {
        return this.$store.getters[`${this.parentRoute}Store/parking`]?.type;
      },
      set(type) {
        this.$store.commit(`${this.parentRoute}Store/SET_PARKING_TYPE`, type);
      },
    },
    typeOptions() {
      return [
        {
          value: this.$t('parkingArea.type.options.publicParkingSpace'),
          label: this.$t('parkingArea.type.options.publicParkingSpace'),
        },
        {
          value: this.$t('parkingArea.type.options.privateParkingSpace'),
          label: this.$t('parkingArea.type.options.privateParkingSpace'),
        },
        {
          value: this.$t('parkingArea.type.options.placeOfDelivery'),
          label: this.$t('parkingArea.type.options.placeOfDelivery'),
        },
        {
          value: this.$t('parkingArea.type.options.doubleParked'),
          label: this.$t('parkingArea.type.options.doubleParked'),
        },
        {
          value: this.$t('parkingArea.type.options.busLane'),
          label: this.$t('parkingArea.type.options.busLane'),
        },
        {
          value: this.$t('parkingArea.type.options.sidewalk'),
          label: this.$t('parkingArea.type.options.sidewalk'),
        },
      ];
    },
    portageSync: {
      get() {
        return this.$store.getters[`${this.parentRoute}Store/parking`]?.portage;
      },
      set(portage) {
        this.$store.commit(`${this.parentRoute}Store/SET_PARKING_PORTAGE`, portage);
      },
    },
    isPortageMore50() {
      return this.isMoreThan50(this.portageSync);
    },
    portageOptions() {
      return [
        {
          value: '0-10 m',
          label: this.$t('parkingArea.portage.options.first'),
        },
        {
          value: '10-20 m',
          label: this.$t('parkingArea.portage.options.second'),
        },
        {
          value: '20-30 m',
          label: this.$t('parkingArea.portage.options.third'),
        },
        {
          value: '30-40 m',
          label: this.$t('parkingArea.portage.options.fourth'),
        },
        {
          value: '40-50 m',
          label: this.$t('parkingArea.portage.options.fifth'),
        },
        {
          value: this.plus50Value,
          label: this.$t('parkingArea.portage.options.sixth'),
        },
      ];
    },
    plus50Value() {
      return this.isMoreThan50(this.portageSync)
        ? this.portageSync
        : '50-60 m';
    },
    vlSync: {
      get() {
        return this.$store.getters[`${this.parentRoute}Store/parking`]?.vl;
      },
      set(vl) {
        this.$store.commit(`${this.parentRoute}Store/SET_PARKING_VL`, vl);
      },
    },
    parentRoute() {
      return this.$route.path.split('/')[1];
    },
  },
  methods: {
    isMoreThan50(value) {
      return value !== ''
        && value !== '0-10 m'
        && value !== '10-20 m'
        && value !== '20-30 m'
        && value !== '30-40 m'
        && value !== '40-50 m';
    },
  },
  watch: {
    portageNumber(portage) {
      this.$store.commit(`${this.parentRoute}Store/SET_PARKING_PORTAGE`,
        `${portage - 10}-${portage} m`);
    },
    portageSync: {
      handler(value) {
        if (value === '50-60 m') {
          if (this.portageNumber !== 60) this.portageNumber = 60;
        } else if (this.isMoreThan50(value)) {
          const number = value.split('-')[1];
          if (number) {
            const portageNumber = parseInt(number.slice(0, number.length - 1), 10);
            if (this.portageNumber !== portageNumber) this.portageNumber = portageNumber;
          }
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
.parking-area {
}

::v-deep {
  .type-buttons {
    flex: initial;
  }

  .portage-options-button {
    padding: 15px 0;
    white-space: nowrap;
  }
}
</style>
